import Vue from 'vue'
import Router from 'vue-router'
/* componentsPages */
import Forbidden from 'components/403';
import NotFound from 'components/404';
/* componentsPages */

/* templates */

    /* template2 */
    //page
    import PG010MainPage_temp2 from './templates/template2/pages/PG010MainPage.vue';
    import Regist_temp2 from './templates/template2/pages/Regist.vue';
    //commonPage
    import Warning_temp2 from './templates/template2/commonPages/Warning.vue';
    import SorryPage_temp2 from './templates/template2/commonPages/SorryPage.vue';
    import LimitUserAccess_temp2 from './templates/template2/commonPages/LimitUserAccess.vue';
    import SessionError_temp2 from './templates/template2/commonPages/SessionError.vue';
    import Mente_temp2 from './templates/template2/commonPages/Mente.vue';
    import ErrorPage_temp2 from './templates/template2/commonPages/ErrorPage.vue';
    //shopper
    import SH060ShopperInfoConfirmError_temp2 from './templates/template2/shopper/SH060ShopperInfoConfirmError.vue';
    /* template2 */

/* templates */

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: [
        /* componentsPages */
        {
            path: '/403Forbidden',
            name: 'Forbidden',
            components: {
                template2: Forbidden
            }
        },
        {
            path: '/404NotFound',
            name: 'NotFound',
            components: {
                template2: NotFound
            }
        },
        /* componentsPages */

        /* comps */
        /* comps/site */
            {
                path: '/:site'
            },
            //commonPage
            { 
                path: '/:site/Warning',
                name: 'Warning',
                components: {
                    template2: Warning_temp2,
                }
            },
            {
                path: '/:site/sorry',
                name: 'SorryPage',
                components: {
                    template2: SorryPage_temp2,
                }
            },
            {
                path: '/:site/limituseraccess',
                name: 'LimitUserAccess',
                components: {
                    template2: LimitUserAccess_temp2,
                }
            },
            {
                path: '/:site/session-timeout',
                name: 'SessionError',
                components: {
                    template2: SessionError_temp2,
                }
            },
            {
                path: '/:site/mente',
                name: 'Mente',
                components: {
                    template2: Mente_temp2,
                }
            },
            {
                path: '/:site/error',
                name: 'ErrorPage',
                components: {
                    template2: ErrorPage_temp2,
                }
            },
            //commonPage
            //pages
            { 
                path: '/:site/PG010MainPage',
                name: 'PG010MainPage',
                components: {
                    template2: PG010MainPage_temp2,
                }
            },
            { 
                path: '/:site/c/:categoryCd',
                name: 'PG020Page', 
                components: {
                    template2: PG010MainPage_temp2,
                }
            },
            { 
                path: '/:site/i/:sItemNo',
                name: 'PG030Page', 
                components: {
                    template2: PG010MainPage_temp2,
                }
            },
            { 
                path: '/:site/lp/:sItemNolP',
                name: 'PG050Page', 
                components: {
                    template2: PG010MainPage_temp2,
                }
            },
            /* 404 NotFound, always end of router array */
            {
                path: '*',
                components: {
                    template2: NotFound,
                    notfound: NotFound
                }
            },
            {
                path: '/:site/404NotFound',
                components: {
                    template2: NotFound
                }
            },
            { 
                path: '/:site/:customUrl',
                components: {
                    template2: PG010MainPage_temp2,
                }
            },
            { 
                path: '/:site/Regist',
                name: 'Regist', 
                components: {
                    template2: Regist_temp2,
                }
            },
            //pages
            //shopper
            { 
                path: '/:site/SH060ShopperInfoConfirmError',
                name: 'SH060ShopperInfoConfirmError',
                components: {
                    template2: SH060ShopperInfoConfirmError_temp2,
                }
            },
            //shopper
        /* comps/site */
    ]
})

router.beforeEach((to, from, next) => {
    var path = to.path.split('/');
    var query = to.query;
    var params = to.params;
    if (path[1] == '404NotFound') {
        next({path: path[1]});
    } else if (path[1] == '403Forbidden') {
        next({path: path[1]});
    } else if ( path[2] == 'PG010MainPage' && query.pageNo == undefined && params.pageNo == undefined && query.sbpEmv3dsStatus != undefined) {
        if (query.sbpEmv3dsStatus.indexOf("sh060_") >= 0){
            let status = query.sbpEmv3dsStatus.replace("sh060_", "");
            next({path: path[1]+'/PG010MainPage?pageNo=22&sbpEmv3dsStatus=' + status});
        }else if(query.sbpEmv3dsStatus.indexOf("pt402_") >= 0){
            let status = query.sbpEmv3dsStatus.replace("pt402_", "");
            next({path: path[1]+'/PG010MainPage?pageNo=86&sbpEmv3dsStatus=' + status});
        }
    } else if ( path[2] == 'PG010MainPage' && query.pageNo == undefined && params.pageNo == undefined) {
        next({path: path[1]+'/PG010MainPage?pageNo=1'});
    } else if (path[1] == path[2]) {
        next({name: 'PG010MainPage',params:{site: path[1]}, query: { pageNo: 1}});
    } else if ( path[2] == null || path[2] == ''
                || path[2] == undefined && query.pageNo == undefined && params.pageNo == undefined) {
        next({path: path[1]+'/PG010MainPage?pageNo=1'});
    } else {
        next();
    }
})

export default router